import { FC, useMemo } from "react";

import { DataId } from "../../../DataId";
import { MenuButton } from "../../../MenuButton";
import { ActionProps } from "../Action";

/**
 * The `ActionMenu` component properties.
 */
export interface ActionMenuProps {
  /**
   * The row ID.
   */
  readonly id: DataId;

  /**
   * The items.
   */
  readonly items?: ReadonlyArray<ActionProps>;
}

/**
 * An action menu.
 */
export const ActionMenu: FC<ActionMenuProps> = (props) => {
  const { id, items } = props;

  const clickHandlers = useMemo(() => items?.map((props) => () => props.onClick?.(id)), [id, items]);
  const disabledStates = useMemo(() => items?.map((props) => props.disabled?.(id)), [id, items]);

  return (
    <MenuButton className="action menu" icon="ellipsis-vertical" size="small" appearance="text" testId="table-action-menu">
      {items?.map((props, index) => (
        <MenuButton.Item key={index} disabled={disabledStates?.[index]} onClick={clickHandlers?.[index]}>
          {/* @ts-ignore */}
          {props.tooltip}
        </MenuButton.Item>
      ))}
    </MenuButton>
  );
};
